export const TIMEDELAY_FORM_LAYOUT = `<label class="col-sm-12">Depois de quantos segundos o elemento aparecerá?</label>
<div class="col-sm-12">
  <input type="number" id="form-time-delay" class="form-control form-control-sm" placeholder="50" min="0"/>
  <p style="margin-top: 5px;"><span class="text-muted" style="font-size: 15px !important;">Ex: 720</span></p>
  <p class="text-muted" style="margin-top: 5px; font-size: 12px !important; font-style: italic;">
    *Informando um valor diferente de zero, o elemento ficará escondido na página final. Tornando-se visível somente ao final do tempo informado.
  </p>
</div>
<hr />`;